
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: '田中 美香',
      age: '45歳',
      condition: '肩こり・腰痛',
      comment: '長年悩んでいた肩こりが、こちらの治療で劇的に改善しました。先生方の丁寧な説明と優しい対応に感謝しています。',
      rating: 5
    },
    {
      name: '佐藤 健太',
      age: '28歳',
      condition: 'スポーツ外傷',
      comment: 'サッカーで怪我をした際にお世話になりました。的確な治療とリハビリ指導のおかげで、早期復帰することができました。',
      rating: 4
    },
    {
      name: '山田 花子',
      age: '62歳',
      condition: '膝の痛み',
      comment: '膝の痛みで歩くのも辛かったのですが、治療を受けてから日常生活が楽になりました。スタッフの皆さんも親切です。',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">患者様の声</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            当院で治療を受けられた患者様からいただいた貴重なお声をご紹介します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-[#3cb371]/20 rounded-full flex items-center justify-center mr-4">
                <i className="ri-user-line text-[#3cb371] text-xl"></i>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">田中 美香</h4>
                <p className="text-sm text-gray-600">45歳 / 肩こり・腰痛</p>
              </div>
            </div>
            <div className="flex mb-4">
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
            </div>
            <p className="text-gray-700 leading-relaxed">
              "長年悩んでいた肩こりが、こちらの治療で劇的に改善しました。先生方の丁寧な説明と優しい対応に感謝しています。"
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-[#3cb371]/20 rounded-full flex items-center justify-center mr-4">
                <i className="ri-user-line text-[#3cb371] text-xl"></i>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">佐藤 健太</h4>
                <p className="text-sm text-gray-600">28歳 / スポーツ外傷</p>
              </div>
            </div>
            <div className="flex mb-4">
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-line text-gray-300"></i>
            </div>
            <p className="text-gray-700 leading-relaxed">
              "サッカーで怪我をした際にお世話になりました。的確な治療とリハビリ指導のおかげで、早期復帰することができました。"
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-[#3cb371]/20 rounded-full flex items-center justify-center mr-4">
                <i className="ri-user-line text-[#3cb371] text-xl"></i>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">山田 花子</h4>
                <p className="text-sm text-gray-600">62歳 / 膝の痛み</p>
              </div>
            </div>
            <div className="flex mb-4">
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
              <i className="ri-star-fill text-yellow-400"></i>
            </div>
            <p className="text-gray-700 leading-relaxed">
              "膝の痛みで歩くのも辛かったのですが、治療を受けてから日常生活が楽になりました。スタッフの皆さんも親切です。"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
